import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AuthApi } from "../../../api/AuthApi";
const initialState = {
  status: false,
  message: "",
  data: {},
  currentRequestId: undefined,
  loading: "idle",
  action: "",
  error: null,
};

export const checkUsername = createAsyncThunk(
  "auth/checkUsername",
  async (username, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().signup;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await AuthApi.checkUsername({ username });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
export const setUsername = createAsyncThunk(
  "auth/setUsername",
  async (payload, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().signup;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await AuthApi.setUsername(payload);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
export const signUp = createAsyncThunk(
  "auth/signUp",
  async (authData, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().signup;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await AuthApi.signUp({ values: authData });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const signUpSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(signUp.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.error = null;
        }
      })
      .addCase(signUp.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = action.payload;
          state.status = action.payload.status;
          state.currentRequestId = undefined;
          state.action = "sign_up";
        }
      })
      .addCase(signUp.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error =
            action.payload?.message ||
            action.error?.message ||
            "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(checkUsername.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.error = null;
        }
      })
      .addCase(checkUsername.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = action.payload;
          state.status = action.payload.status;
          state.currentRequestId = undefined;
          state.action = "check_username";
        }
      })
      .addCase(checkUsername.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error =
            action.payload?.message ||
            action.error?.message ||
            "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(setUsername.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.error = null;
        }
      })
      .addCase(setUsername.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = { ...state.data, username_data: action.payload };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
          state.action = "set_username";
        }
      })
      .addCase(setUsername.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error =
            action.payload?.message ||
            action.error?.message ||
            "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      });
  },
});

export default signUpSlice.reducer;
